import { render, staticRenderFns } from "./RecommendationLanguageWrapper.vue?vue&type=template&id=107e7928&"
import script from "./RecommendationLanguageWrapper.vue?vue&type=script&lang=js&"
export * from "./RecommendationLanguageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationLanguageWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports